/**
 * External dependencies
 */
import inherits from 'inherits';

export default class RentalPlan {
    
    constructor(cscom) {
        if (!(this instanceof RentalPlan)) {
            return new RentalPlan(cscom);
        }
        this.cscom = cscom;
    }

    list(data) {
        return this.cscom.req.get('/customer-site-api/rental-plans/list', null, data);
    }

}
